import { showNotify } from "vendor/application/disptach";
import { IntentsAPI } from "../../infrastructure";


export const saveIntent = async ({ sendIntent, actualProject, access, dispatch }) => {
  try {
    const obj = new IntentsAPI(actualProject.id, access, {dispatch, ...sendIntent }, sendIntent, );
    await obj.put_intent();

    dispatch(
      showNotify({ message: "intents", type: "edit", severity: "success" })
    );
  } catch (err) {
    dispatch(showNotify({ message: err.message || err.responseJSON.message, severity: "error" }));
  }
};